import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import 'moment/locale/pt-br';
import moment from 'moment';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import { instanceAxios } from '../../InstanceAxios';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import FilterIcon from '@material-ui/icons/FilterList';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '95%',
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    top: `50%`,
    left: `50%`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

function Cupons() {
  const classes = useStyles();
  const [ready, setReady] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [filterText, setFilterText] = useState('');
  const [columnId, setColumnId] = useState('');
  const [idOrder, setIdOrder] = useState('');
  const [originalUsuariosTour, setOriginalUsuariosTour] = useState([]);
  const [usuariosTour, setUsuariosTour] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');
  const [columns, setColumns] = useState([
    { id: 'nome', label: 'Nome', minWidth: 140, filterable: true },
    { id: 'telefone', label: 'Telefone', minWidth: 140, filterable: true },
    { id: 'email', label: 'Email', minWidth: 80, filterable: true },
    { id: 'data', label: 'Data', minWidth: 140, filterable: true },
    { id: 'horario', label: 'Horário', minWidth: 140, filterable: true },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(0);
  const [dtInicial, setDtInicial] = useState(
    moment('2020-01-01').format('YYYY-MM-DD')
  );
  const [dtFinal, setDtFinal] = useState(moment().format('YYYY-MM-DD'));
  const [order, setOrder] = useState('DESC');

  useEffect(() => {
    fetchUsuariosTour(10, 0, dtInicial, dtFinal, order);
  }, []);

  const clickAlert = () => {
    setAlert(false);
    setAlertType('');
    setMessage('');
  };

  const fetchUsuariosTour = async (l, p, dtI, dtF, o) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(`/tour?limit=${l}&page=${p}&dtInicio=${dtI}&dtFim=${dtF}&order=${o}`)
      .then((res) => {
        const rows = Array.isArray(res?.data?.rows) ? res.data.rows : [];

        console.log(res.data);
        setUsuariosTour(rows);
        setOriginalUsuariosTour(rows);
        setCount(res?.data?.count || 0);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setUsuariosTour([]);
        setCount(0);
        setMessage('Erro ao atualizar Pagamentos,tente novamente mais tarde!');
        setAlertType('error');
        setAlert(true);
        setReady(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchUsuariosTour(limit, newPage, dtInicial, dtFinal, order);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setLimit(event.target.value);
    fetchUsuariosTour(event.target.value, page, dtInicial, dtFinal, order);
  };

  const handleDataIncial = async (data) => {
    const dt = moment(data).format('YYYY-MM-DD');
    setDtInicial(dt);
    fetchUsuariosTour(limit, page, dt, dtFinal, order);
  };

  const handleDataFinal = async (data) => {
    const dt = moment(data).format('YYYY-MM-DD');
    setDtFinal(dt);
    fetchUsuariosTour(limit, page, dtInicial, dt, order);
  };

  const handleOrder = async () => {
    const o = order === 'ASC' ? 'DESC' : 'ASC';
    setOrder(o);
    fetchUsuariosTour(limit, page, dtInicial, dtFinal, o);
  };

  const openModalFilter = (event, columnid) => {
    setFilterText('');
    const rect = event.target.getBoundingClientRect();
    setIsModalOpen(true);
    setModalPosition({ top: rect.top, left: rect.left });
    setColumnId(columnid);
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  // Function to filter the table data
  const filterTable = () => {
    setIsModalOpen(false);

    const filteredDas = originalUsuariosTour.filter((item) => {
      const value = getValueColumnId(columnId, item);
      return (
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    });
    // Update the table data with filtered data
    setUsuariosTour(filteredDas);
  };

  const getValueColumnId = (columnIdAux, rowData) => {
    columnIdAux = columnIdAux.replace(/"/g, '');

    const parts = columnIdAux.split('.');

    let result = null;
    for (let part of parts) {
      if (result === null) {
        // If result is null, assign the global object to result
        result = rowData[part];
      } else {
        // If result is not null, access the property
        result = result[part];
      }
    }
    return result;
  };

  const clearFilter = () => {
    setIsModalOpen(false);
    setFilterText('');
    setUsuariosTour(originalUsuariosTour);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleRequestSort = (property) => {
    const orderBy = property;

    if (idOrder === property && order === 'desc') {
      setOrder('asc');
    } else {
      setOrder('desc');
    }

    setIdOrder(orderBy);
  };

  const sortTable = (property) => {
    const isAsc = order === 'asc';
    const usuariosOrdenados = Array.isArray(usuariosTour)
      ? [...usuariosTour]
      : [];

    usuariosOrdenados.sort((a, b) => {
      let aValue = getValueColumnId(property, a);
      let bValue = getValueColumnId(property, b);
      // If the property is a string, convert to lowercase for case-insensitive sorting
      if (typeof aValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }
      if (aValue < bValue) {
        return isAsc ? -1 : 1;
      }
      if (aValue > bValue) {
        return isAsc ? 1 : -1;
      }
      return 0;
    });
    setUsuariosTour(usuariosOrdenados);
  };

  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        style={{ top: modalPosition.top, left: modalPosition.left }}
      >
        <div
          style={{
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '5px',
            width: '300px',
          }}
        >
          <TextField
            label="Filtrar"
            variant="outlined"
            value={filterText}
            onChange={handleFilterTextChange}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            onClick={filterTable}
            style={{ marginTop: '10px' }}
          >
            Filtrar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={clearFilter}
            style={{ marginTop: '10px', marginLeft: '5px', width: 70 }}
          >
            Limpar
          </Button>
        </div>
      </Modal>
      <Collapse in={alert}>
        <Alert severity={alertType} onClick={clickAlert}>
          {message}
        </Alert>
      </Collapse>
      <Paper>
        <Collapse in={ready}>
          <Grid
            container
            style={{ paddingLeft: 10, paddingRight: 10, paddingTop: '1%' }}
          >
            <Grid item xs={12}>
              <div align="center">
                <h1>Usuários Tour</h1>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div align="right">
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={ptBrLocale}
                >
                  <Grid container justify="space-around">
                    <KeyboardDatePicker
                      margin="normal"
                      id="picker-inicio"
                      label="Data Inicial"
                      format="dd/MM/yyyy"
                      value={dtInicial}
                      onChange={handleDataIncial}
                      KeyboardButtonProps={{
                        'aria-label': 'Mudar Data Inicial',
                      }}
                    />

                    <IconButton
                      className={classes.margin}
                      size="small"
                      onClick={handleOrder}
                    >
                      {order === 'DESC' ? (
                        <ArrowDownwardIcon fontSize="inherit" />
                      ) : (
                        <ArrowUpwardIcon fontSize="inherit" />
                      )}
                    </IconButton>
                    <KeyboardDatePicker
                      margin="normal"
                      id="picker-final"
                      label="Data Final"
                      format="dd/MM/yyyy"
                      value={dtFinal}
                      onChange={handleDataFinal}
                      KeyboardButtonProps={{
                        'aria-label': 'Mudar Data Final',
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </div>
            </Grid>
          </Grid>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <TableSortLabel
                        active={idOrder === column.id}
                        direction={idOrder === column.id ? order : 'asc'}
                        onClick={() => {
                          handleRequestSort(column.id);
                          setTimeout(() => {
                            sortTable(column.id);
                          }, 200);
                        }}
                      >
                        {column.label}
                      </TableSortLabel>

                      {column.filterable && (
                        <IconButton
                          style={{ marginLeft: -5 }}
                          onClick={(event) => openModalFilter(event, column.id)}
                          aria-label="filtra"
                        >
                          <FilterIcon style={{ width: 16, height: 16 }} />
                        </IconButton>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(Array.isArray(usuariosTour) ? usuariosTour : []).map((u) => {
                return (
                  <TableRow key={u.id}>
                    <TableCell align="center" component="th" scope="row">
                      {u.nome}
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      {u.telefone}
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      {u.email}
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      {u.data_acesso}
                    </TableCell>
                    <TableCell align="center" component="th" scope="row">
                      {u.hora_acesso}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={limit}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>
    </>
  );
}

export default Cupons;
